var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalon2WHite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salon_2_WHite",
    "data-name": "Salon 2_WHite",
    xmlns: "http://www.w3.org/2000/svg",
    width: 201.436,
    height: 201.445,
    viewBox: "0 0 201.436 201.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbfaf1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M201.447,38.362a8.86,8.86,0,0,0-8.85-8.856h-38.76V17.2A8.856,8.856,0,0,0,150.884,0H50.556a8.856,8.856,0,0,0-2.947,17.2V29.508H8.846A8.856,8.856,0,0,0,5.893,46.7V180.8a2.953,2.953,0,0,0,2.953,2.943H65.308L48.786,196.133a2.953,2.953,0,0,0,1.768,5.312H150.882a2.953,2.953,0,0,0,1.774-5.312l-16.52-12.393H192.6a2.953,2.953,0,0,0,2.943-2.943h0V46.7a8.856,8.856,0,0,0,5.906-8.341Zm-47.6,8.85h35.8V147.54H153.838ZM50.556,5.9H150.884a2.953,2.953,0,1,1,0,5.9H62.358a2.953,2.953,0,0,0,0,5.9h85.591V177.835h-5.914v-62.75a2.953,2.953,0,0,0-2.953-2.963H62.358a2.953,2.953,0,0,0-2.947,2.953v62.79H53.5V14.74a2.953,2.953,0,0,0-2.953-2.953h0a2.953,2.953,0,0,1,0-5.9Zm53.118,171.965V141.638h20.65v36.2Zm-26.559,0V141.638H97.771v36.2Zm50.164-42.1H74.165a2.953,2.953,0,0,0-2.953,2.953h0v39.146h-5.9V118.032h70.825v59.8h-5.9V138.69a2.953,2.953,0,0,0-2.953-2.953ZM47.606,47.211V147.54H11.8V47.211Zm-38.76-11.8h38.76v5.9H8.846a2.953,2.953,0,1,1,0-5.9ZM11.8,153.44h35.8v24.4H11.8Zm130.227,42.1H59.409l15.739-11.8H126.3Zm11.8-17.7v-24.4h35.8v24.4ZM192.6,41.309H153.832v-5.9H192.6a2.953,2.953,0,0,1,0,5.9Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M35.375,138.621H53.483a2.953,2.953,0,0,0,2.953-2.953V100.243a2.953,2.953,0,0,0-2.953-2.953H35.375a2.953,2.953,0,0,0-2.947,2.953h0v35.408a2.953,2.953,0,0,0,2.947,2.969Zm2.953-35.408h12.2v29.506H38.332Z",
    transform: "translate(-14.735 -44.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M313.651,97.29h-18.1a2.953,2.953,0,0,0-2.947,2.953h0v35.408a2.953,2.953,0,0,0,2.947,2.969h18.1a2.953,2.953,0,0,0,2.947-2.953V100.243a2.953,2.953,0,0,0-2.947-2.953ZM310.7,132.7H298.5v-29.48h12.2Z",
    transform: "translate(-132.871 -44.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M35.375,225.089H53.483a2.953,2.953,0,0,0,2.953-2.947V186.727a2.953,2.953,0,0,0-2.953-2.947H35.375a2.947,2.947,0,0,0-2.947,2.947v35.414A2.947,2.947,0,0,0,35.375,225.089Zm2.953-35.408h12.2v29.48H38.332Z",
    transform: "translate(-14.735 -83.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M313.651,183.78h-18.1a2.947,2.947,0,0,0-2.947,2.947v35.414a2.947,2.947,0,0,0,2.947,2.947h18.1a2.947,2.947,0,0,0,2.947-2.947V186.727A2.947,2.947,0,0,0,313.651,183.78ZM310.7,219.188H298.5v-29.48h12.2Z",
    transform: "translate(-132.871 -83.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M142.211,74.48h-18.1a2.953,2.953,0,0,0-2.947,2.953h0v35.408a2.953,2.953,0,0,0,2.947,2.953h18.1a2.953,2.953,0,0,0,2.947-2.953V77.433A2.953,2.953,0,0,0,142.211,74.48Zm-2.951,35.414H127.08V80.414h12.2Z",
    transform: "translate(-55.025 -33.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M226.509,75.93H208.433a2.953,2.953,0,0,0-2.953,2.943h0v35.412a2.953,2.953,0,0,0,2.953,2.953h18.076a2.953,2.953,0,0,0,2.947-2.953V78.873A2.947,2.947,0,0,0,226.509,75.93Zm-2.953,35.408H211.382V81.858h12.2Z",
    transform: "translate(-93.313 -34.479)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalon2WHite);
export default __webpack_public_path__ + "static/media/Salon 2_WHite.dfde573f6985fd6a08fd230b290f9372.svg";
export { ForwardRef as ReactComponent };